import React from "react";
import Reveal from "../common/Reveal";

export default function Contact() {
  return (
    <section id="contact" className="section" style={{ paddingBottom: "40px" }}>
      <div className="section-inner">
        <Reveal className="contact-block">
          <span className="section-label mono">07 / CONTACT</span>
          <h2 className="contact-headline">
            Let's build something worth shipping.
          </h2>
          <p className="contact-sub">
            Open to roles, collaborations, and the occasional side quest. The
            inbox is always on.
          </p>
          <a
            className="lnk contact-btn mono"
            href="mailto:johnpauloramil.guimalan@gmail.com"
          >
            johnpauloramil.guimalan@gmail.com ↗
          </a>
          <div className="contact-socials mono">
            <a
              className="lnk contact-social-link"
              href="https://github.com/PaoloGuimalan"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>
            <a
              className="lnk contact-social-link"
              href="https://www.linkedin.com/in/john-paulo-ramil-guimalan-89029321a/"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
            </a>
            <a
              className="lnk contact-social-link"
              href="https://www.instagram.com/paologuimalan/"
              target="_blank"
              rel="noreferrer"
            >
              Instagram
            </a>
            <a
              className="lnk contact-social-link"
              href="https://www.facebook.com/paulo.portesguimalan/"
              target="_blank"
              rel="noreferrer"
            >
              Facebook
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
